import React from 'react';

import PropTypes from 'prop-types';

// Components
import { Mui } from 'components';

const useStyles = Mui.makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.grey[100],
    color: theme.palette.text.secondary,
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(0.5, 1.5),
    textTransform: 'none',
    justifyContent: 'flex-start',
    fontWeight: 'normal',
    boxShadow: 'none',
    '&:hover': {
      backgroundColor: theme.palette.grey[200],
      boxShadow: 'none',
    },
  },
  label: { width: '100%' },
  shortcut: {
    backgroundColor: theme.palette.background.paper,
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: 4,
    padding: '2px 6px',
    fontSize: '0.75rem',
    fontWeight: 'bold',
    marginLeft: theme.spacing(1),
  },
}));

function Trigger({ className, placeholder = 'Pesquisar...', ...rest }) {
  const classes = useStyles();
  const isMac =
    typeof window !== 'undefined'
      ? /Mac|iPod|iPhone|iPad/i.test(navigator.userAgentData?.platform || navigator.userAgent)
      : false;
  const shortcut = isMac ? '⌘K' : 'Ctrl+K';

  const handleClick = () => {
    window.dispatchEvent(new Event('open-command-palette'));
  };

  return (
    <Mui.Button
      color="default"
      variant="contained"
      classes={{
        root: `${classes.root} ${className || ''}`,
        label: classes.label,
      }}
      onClick={handleClick}
      startIcon={<Mui.Icon fontSize="small">search</Mui.Icon>}
      disableElevation
      {...rest}>
      <Mui.Box flex={1} textAlign="left">
        {placeholder}
      </Mui.Box>
      <span className={classes.shortcut}>{shortcut}</span>
    </Mui.Button>
  );
}

Trigger.propTypes = {
  className: PropTypes.string,
  placeholder: PropTypes.string,
};

export default Trigger;
